import { HttpResponse, HttpService } from '@application/http.service';
import { ReceptionVisitInput } from '@visiba/api-vcs-client-v2';
import { Injectable } from '@visiba/instantiation';
import { ParameterHandler } from '@visiba/std';
import { ApiBaseClient } from './_api_base_client';

@Injectable()
export class RecentReceptionsApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('Receptions');
	}

	public async getRecentlyVisited(count: number): HttpResponse<ReceptionVisitInput[]> {
		const parameterHandler = new ParameterHandler();
		parameterHandler.append({
			count,
		});

		return this.httpService.get(`${this.baseUri}/recentlyVisited${parameterHandler.getString()}`);
	}

	public async postToRecentlyVisited(receptionId: number): HttpResponse<unknown> {
		return this.httpService.post(`${this.baseUri}/recentlyVisited`, { ReceptionId: receptionId });
	}

	public async delete(receptionId: number): HttpResponse<unknown> {
		return this.httpService.delete(`${this.baseUri}/recentlyVisited/${receptionId}`);
	}
}
